module.exports = __webpack_public_path__ + "static/media/shopify.ef26b50f.png";